// Copyright 2024 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';
import styles from './BooleanFieldState.module.css';

export const BooleanFieldState = ({ val, label, onChange, fullScreen, labelAfter = false }) => {
  return (
    <label className={`${styles.runDownFStoggle} ${fullScreen ? styles.fullScreen : ''}`}>
      {val !== '' ? (
        <>
          {labelAfter ? null : label}
          <input
            type='checkbox'
            checked={val}
            onChange={onChange}
            className={styles.BooleanFieldInput}
          />
          {labelAfter ? label : null}
        </>
      ) : null}
    </label>
  );
};
